var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page-container"},[(this.business === true)?_c('b2bHome'):_c('b2cHome')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2121c4f1","hasScoped":false,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Home/home.vue
// module id = null
// module chunks = 